import { ConnectedNavLoader as NavLoader } from "./connected-nav-loader";
import { ConnectedNavLoaderProxy } from "./connected-nav-loader-proxy";

NavLoader.Proxy = ConnectedNavLoaderProxy;

export * from "./basic-loader";
export { NavLoader };
